if (!customElements.get('signup-modal')) {
  customElements.define(
    'signup-modal',
    class SignupModal extends ModalDialog {
      constructor() {
        super();

        // Grab cookie values on mount

        // Shopify generated
        const nativeLocale = this.getCookie('localization');
        // Orbe generated
        const appLocale = this.getCookie('mdApp_countryCodeDomain');
        const hasLocaleClosed = this.getCookie('mdApp_cookieModalTime');
        // This custom el
        const hasModalClosed = this.getCookie('signup-modal-closed');

        // Create the helper cookie if a suers closes the country / location modal without confirming
        if (document.querySelector(`form#md-modal__form__id button.md-modal-closeButton`)) {
          document
            .querySelector(`form#md-modal__form__id button.md-modal-closeButton`)
            .addEventListener('click', (e) => {
              this.setCookie('closed-locale-form', 'true', 30);
              this.setAttribute('data-locale-closed', true);
            });
        }

        if (window.designMode.enabled !== 'true') {
          this.delay = parseInt(this.dataset.delay) || 9000;
          this.checkSubmission(nativeLocale, appLocale, hasModalClosed, hasLocaleClosed);
        } else {
          this.addEventListeners();
        }

        this.forceOpen();
      }

      // listen to these data attributes
      static get observedAttributes() {
        return ['data-locale-closed'];
      }

      // if any of the watched values above change, this function will run
      attributeChangedCallback(name, oldValue, newValue) {
        if (name == 'data-locale-closed') {
          const nativeLocale = this.getCookie('localization');
          const appLocale = this.getCookie('mdApp_countryCodeDomain');
          const hasModalClosed = this.getCookie('signup-modal-closed');
          const hasLocaleClosed = this.getCookie('mdApp_cookieModalTime');
          this.checkSubmission(nativeLocale, appLocale, hasModalClosed, hasLocaleClosed);
        }
      }

      /**
       * Check if the form has been submitted
       * This is checking for the URL param ?customer_posted=true
       */
      checkSubmission(l, a, c, m) {
        // Get URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const customerPosted = urlParams.get('customer_posted');

        if (!customerPosted) {
          this.checkCookie(l, a, c, m);
          return;
        }

        if (customerPosted === 'true') {
          this.show();
          setCookie('signup-modal-closed', 'true', 340);
          this.successMessage();
        } else {
          this.checkCookie(l, a, c, m);
        }
      }

      /**
       * Check if the cookie has been set
       * If it hasn't been set, show the modal
       *
       * @param {String} l - Locale (Shopiy) - Shopify default predicted locale code
       * @param {String} a - App local (Orbe) - Orbes locale code (applies once users has confimed thier location)
       * @param {String} c - Closed - Has the signup modal closed?
       * @param {String} m - ModalClosed - This gets set to true when the user closes the country selector without confirming their location
       */
      checkCookie(l, a, c, m) {
        const hasClosed = this.getCookie('closed-locale-form');

        if (l == a || m == 'true' || hasClosed == 'true') {
          if (this.getCookie('signup-modal-closed') == undefined) {
            setTimeout(() => {
              this.show();
            }, this.delay);
          }
        }
      }

      successMessage() {
        const items = document.querySelectorAll('.js-sign-up-success');

        items.forEach((item) => {
          item.classList.add('is-hidden');
        });
      }

      hide() {
        super.hide();
        this.setCookie('signup-modal-closed', 'true', 5);
      }

      show(opener) {
        super.show(opener);
      }

      /**
       * This is for the theme editor
       * This will display the modal when the user is editing the section
       */
      addEventListeners() {
        document.addEventListener('shopify:section:select', (event) => {
          this.hide();
          const id = event.detail.sectionId;
          if (id != 'sign-up-modal') {
            return;
          }
          const opener = `#SignupModal-${id} button`;
          this.show(opener);
        });

        document.addEventListener('shopify:section:deselect', (event) => {
          this.hide();
        });
      }

      forceOpen() {
        const urlParams = new URLSearchParams(window.location.search);
        const signup_modal = urlParams.get('signup_modal');
        const form_type = urlParams.get('form_type');

        // if url contains /challenge
        if (window.location.pathname.includes('/challenge')) {
          return;
        }

        if (signup_modal === 'true' || form_type === 'customer') {
          this.show();
        }
      }

      getCookie(name) {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');
        if (parts.length === 2) return parts.pop().split(';').shift();
      }

      setCookie(name, value, days) {
        let expires = '';
        if (days) {
          const date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
      }
    },
  );
}
